import { Palette } from 'config';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${Palette.PrimaryGray._100};
`;

export const IncludeSection = styled.div`
  flex-basis: 100%;
  padding-top: 16px;
  padding-right: 16px;
  padding-left: 16px;
  max-width: ${({ isExclude }) => isExclude && '50%'};
  border-right: 2px solid ${Palette.PrimaryGray._200};
  border-left: none;
  overflow: auto;
  overflow-x: hidden;
  min-height: 388px;
  max-height: 388px;
`;

export const ExcludeSection = styled.div`
  max-width: 50%;
  padding: 16px;
  padding-bottom: 0;
  overflow: auto;
  overflow-x: hidden;
  min-height: 388px;
  max-height: 388px;
`;
